module.exports = __webpack_public_path__ + "static/media/iq.bfdb80ad.svg";